import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
    <div class="spinner-container">
      <div class="loader"></div>
    </div>
  `,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
